// extracted by mini-css-extract-plugin
module.exports = {"aside":"Aside_aside__1YUgF","aside-img":"Aside_aside-img__2h44-","aside-info":"Aside_aside-info__mm_s2"};